import {createSlice} from "@reduxjs/toolkit"
const analysisStore = createSlice({
    name:"analysis",
    initialState:{
        selectData:null,
    },
    reducers:{
        changeSelect(state,action){
            state.selectData = action
        }
    }
})
//  导出操作数据的行为函数
export const {changeSelect}  = analysisStore.actions
//  获取reducer函数
const analysisReducer = analysisStore.reducer
//	导出reducer
export default analysisReducer;